import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "_bxsh--base _rounded--common _bgc--white _fo",
  role: "list"
}
const _hoisted_2 = ["href", "data-qa"]
const _hoisted_3 = {
  class: "_grow-1 _fw-eb",
  "data-qa": "box-list-item-name"
}
const _hoisted_4 = {
  class: "gfu-navbar-badge",
  "data-qa": "box-list-item-count"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.items, (item) => {
      return (_openBlock(), _createElementBlock("a", {
        key: item.name,
        href: item.url,
        class: "_flex _gap-2 _ai-c _px-2 _py-2 _tdh-n gfu-link--nofx",
        role: "listitem",
        "data-qa": `box-list-item:${item.name}`
      }, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(item.name), 1 /* TEXT */),
        _createElementVNode("span", _hoisted_4, _toDisplayString(item.count), 1 /* TEXT */),
        _createVNode(_component_base_icon, {
          name: "chevron-right",
          class: "_tc--accent",
          size: "lg",
          "aria-hidden": "true"
        })
      ], 8 /* PROPS */, _hoisted_2))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}